/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import * as Yup from "yup";

import { termsAndConditionsSchema } from "./terms-and-conditions";

/**
 * Validation Schema for Market Details
 */
export const marketSchema = Yup.object()
  .shape({
    tenantUid: Yup.string().required("Region is required"),
  })
  .concat(termsAndConditionsSchema);
